import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationService} from '../../../../services/navigation.service';
import {SearchService} from '../../../../services/search.service';
import {AuthService} from "../../../../services/auth.service";
import {StorageService} from "../../../../services/storage.service";
import {WarehouseService} from '../../../../services/warehouse.service';
import {Notification, NotificationType} from '../../../../models/warehouse.model';
import {Router} from '@angular/router';

@Component({
  selector: 'app-header-sidebar-plain',
  templateUrl: './header-sidebar-plain.component.html',
  styleUrls: ['./header-sidebar-plain.component.scss'],
  standalone: false
})
export class HeaderSidebarPlainComponent implements OnInit, OnDestroy {
  notifications: Notification[] = [];
  unreadCount = 0;
  loadingNotifications = false;
  isUserRole = false;
  username = '';
  private unreadInterval: any;

  constructor(
    public navService: NavigationService,
    public searchService: SearchService,
    private authService: AuthService,
    private storageService: StorageService,
    private warehouseService: WarehouseService,
    private router: Router
  ) { }

  ngOnInit() {
    // Get logged in user info
    const user = this.storageService.getUser();
    this.username = user?.username || 'User';

    // Check if user has ROLE_USER only (not ADMIN or MODERATOR)
    this.isUserRole = user?.roles?.includes('ROLE_USER') &&
      !user?.roles?.includes('ROLE_ADMIN') &&
      !user?.roles?.includes('ROLE_MODERATOR');

    // Only load notifications if NOT ROLE_USER
    if (!this.isUserRole) {
      this.loadNotifications();
      this.loadUnreadCount();
      this.unreadInterval = setInterval(() => this.loadUnreadCount(), 60000);
    }
  }

  ngOnDestroy(): void {
    if (this.unreadInterval) {
      clearInterval(this.unreadInterval);
    }
  }


  toggleSidebar() {
    this.navService.sidebarState.sidenavOpen = !this.navService.sidebarState.sidenavOpen;
    this.navService.sidebarState.childnavOpen = false;
  }

  toggelSidebarMobile() {
    // Toggle sidebar for mobile view
    this.toggleSidebar();
  }

  openSearch() {
    this.searchService.searchOpen = true;
  }

  onNotificationsOpen(open: boolean) {
    // Only load notifications if NOT ROLE_USER
    if (open && !this.isUserRole) {
      this.loadNotifications();
      this.loadUnreadCount();
    }
  }

  loadNotifications() {
    // Skip if ROLE_USER
    if (this.isUserRole) return;
    
    this.loadingNotifications = true;
    this.warehouseService.getAllNotifications().subscribe({
      next: (notifications) => {
        const unread = (notifications || []).filter(n => !n.isRead);
        const sorted = unread.slice().sort((a, b) => {
          const aDate = a.createdAt ? new Date(a.createdAt).getTime() : 0;
          const bDate = b.createdAt ? new Date(b.createdAt).getTime() : 0;
          return bDate - aDate;
        });
        this.notifications = sorted.slice(0, 6);
        this.loadingNotifications = false;
      },
      error: () => {
        this.notifications = [];
        this.loadingNotifications = false;
      }
    });
  }

  loadUnreadCount() {
    // Skip if ROLE_USER
    if (this.isUserRole) return;
    
    this.warehouseService.getUnreadCount().subscribe({
      next: (count) => this.unreadCount = count || 0,
      error: () => this.unreadCount = 0
    });
  }

  getNotificationIcon(type: NotificationType | undefined): string {
    switch (type) {
      case NotificationType.LOW_STOCK:
        return 'i-Empty-Box text-warning';
      case NotificationType.EXPIRY_WARNING:
        return 'i-Calendar text-danger';
      default:
        return 'i-Bell text-primary';
    }
  }

  formatNotificationTime(dateString: string | undefined): string {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffMs = now.getTime() - date.getTime();
      const diffMinutes = Math.floor(diffMs / (1000 * 60));
      if (diffMinutes < 1) return 'tani';
      if (diffMinutes < 60) return `${diffMinutes} min më parë`;
      const diffHours = Math.floor(diffMinutes / 60);
      if (diffHours < 24) return `${diffHours} orë më parë`;
      const diffDays = Math.floor(diffHours / 24);
      if (diffDays < 30) return `${diffDays} ditë më parë`;
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch {
      return dateString;
    }
  }

  navigateToNotifications(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.router.navigate(['/warehouse/notifications']);
  }

  signOut() {
          this.authService.logout().subscribe({
              next: res => {
                  console.log(res);
                  this.storageService.clean();
                  window.location.reload();
              },
              error: err => {
                  console.log(err);
              }
          });
  }
}
